/**
 * Fills `{placeholder}` tokens in a translated string with the given values.
 *
 * Kept deliberately dumb - no plural rules, no gender agreement - because the
 * strings this fills are UI chrome (ADR 0051 §2), not the printed worksheet
 * prompts. Those are per-language template sets with no runtime grammar at
 * all (ADR 0051 §5); this is the same restraint applied to the smaller
 * problem of "Card {current} of {total}".
 */
export function format(template: string, values: Record<string, string | number>): string {
    return template.replace(/\{(\w+)\}/g, (match, key) =>
        Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match
    );
}
